/**
 * DTOs de auditoría y del estado del repartidor de webhooks, consumidos por la consola de
 * operador (docs/FASE-1.md §6, pantallas «Auditoría» y «Salud»). `audit_log` es solo inserción:
 * el API únicamente expone lectura paginada, nunca escritura ni borrado.
 */
import { z } from "zod";
import { PATTERNS } from "../constants.js";
export const AuditActorTypeSchema = z.enum(["user", "operator", "module", "system"]);
export const AuditLogEntrySchema = z.object({
    id: z.uuid(),
    actorType: AuditActorTypeSchema,
    /** Identificador del actor tal como lo registró quien audita: uuid de usuario/operador,
     * `client:<client_id>` de un módulo, o `system`. */
    actorId: z.string(),
    orgId: z.uuid().nullable(),
    action: z.string(),
    targetType: z.string(),
    targetId: z.string(),
    metadata: z.record(z.string(), z.unknown()).nullable(),
    ip: z.string().nullable(),
    createdAt: z.iso.datetime(),
});
/** `GET /audit`. Orden fijo: del más reciente al más antiguo. */
export const ListAuditQuerySchema = z.object({
    actorType: AuditActorTypeSchema.optional(),
    /** Coincidencia por prefijo, p. ej. `operator.login` para todas sus variantes. */
    action: z.string().max(120).optional(),
    orgId: z.uuid().optional(),
    targetType: z.string().max(120).optional(),
    cursor: z.string().optional(),
    limit: z.coerce.number().int().min(1).max(100).default(50),
});
/** Estado del repartidor de webhooks de un módulo (`GET /webhooks/health`). */
export const WebhookModuleHealthSchema = z.object({
    moduleCode: z.string().regex(PATTERNS.MODULE_CODE),
    endpointsActive: z.number().int().nonnegative(),
    endpointsDisabled: z.number().int().nonnegative(),
    /** Entregas por estado. `pending` incluye las que esperan un reintento futuro. */
    pending: z.number().int().nonnegative(),
    failed: z.number().int().nonnegative(),
    delivered: z.number().int().nonnegative(),
    /** `created_at` de la entrega pendiente más antigua; null si no hay ninguna. Es la señal de
     * atasco del repartidor: si crece, algo no está entregando. */
    oldestPendingAt: z.iso.datetime().nullable(),
});
export const WebhookHealthResponseSchema = z.object({
    modules: z.array(WebhookModuleHealthSchema),
    /** Momento en que se calculó, para que la consola pueda mostrar la antigüedad del dato. */
    checkedAt: z.iso.datetime(),
});
//# sourceMappingURL=audit.js.map